import React, { ReactNode } from "react";
import logo from "../../../assets/images/login/treez-logo.png";
import illustPos from "../../../assets/images/login/illust-pos.png";
import illustCatalog from "../../../assets/images/login/illust-catalog.png";
import illustEcommerce from "../../../assets/images/login/illust-ecommerce.png";
import illustIntegrations from "../../../assets/images/login/illust-integrations.png";
import illustPayment from "../../../assets/images/login/illust-payment.png";
import illustAnalytics from "../../../assets/images/login/illust-analytics.png";
import styles from "./AuthShell.module.scss";

export type AuthShellProps = {
    title: string;
    children: ReactNode;
    showMobileIllustration?: boolean;
};

/**
 * Login chrome from the Treez Admin Login handoff.
 * Desktop (≥621px): card + floating illustrations + washes.
 * Mobile (≤620px): gradient + centered column + analytics pulse.
 * Form controls inside `children` should use the DS.
 */
export const AuthShell = ({
    title,
    children,
    showMobileIllustration = true,
}: AuthShellProps) => {
    return (
        <div className={styles.root} data-ui="auth-shell">
            <div aria-hidden className={`${styles.blob} ${styles.blobA}`} />
            <div aria-hidden className={`${styles.blob} ${styles.blobB}`} />
            <div aria-hidden className={`${styles.blob} ${styles.blobC}`} />
            <div aria-hidden className={`${styles.blob} ${styles.blobD}`} />
            <div aria-hidden className={styles.mobileBlobA} />
            <div aria-hidden className={styles.mobileBlobB} />

            <div aria-hidden className={styles.artboard}>
                <div className={styles.artboardFrame}>
                    <div
                        className={`${styles.illustration} ${styles.illustPos}`}
                    >
                        <img alt="" src={illustPos} />
                    </div>
                    <div
                        className={`${styles.illustration} ${styles.illustCatalog}`}
                    >
                        <img alt="" src={illustCatalog} />
                    </div>
                    <div
                        className={`${styles.illustration} ${styles.illustEcommerce}`}
                    >
                        <img alt="" src={illustEcommerce} />
                    </div>
                    <div
                        className={`${styles.illustration} ${styles.illustIntegrations}`}
                    >
                        <img alt="" src={illustIntegrations} />
                    </div>
                    <div
                        className={`${styles.illustration} ${styles.illustPayment}`}
                    >
                        <img alt="" src={illustPayment} />
                    </div>
                    <div
                        className={`${styles.illustration} ${styles.illustAnalytics}`}
                    >
                        <img alt="" src={illustAnalytics} />
                    </div>
                </div>
            </div>

            <div className={styles.stage}>
                <div className={styles.card}>
                    <div className={styles.logoWrap}>
                        <img alt="TREEZ" className={styles.logo} src={logo} />
                    </div>
                    <h1 className={styles.title}>{title}</h1>
                    {children}
                </div>

                {showMobileIllustration ? (
                    <div aria-hidden className={styles.mobileIllustration}>
                        <div>
                            <img alt="" src={illustAnalytics} />
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
};
